import { createTheme } from '@mui/material';
import MetropolisRegular from '@chrismsimpson/metropolis/Fonts/Webfonts/WOFF2/Metropolis-Regular.woff2';

const metropolisRegular = {
  fontFamily: 'MetropolisRegular',
  fontStyle: 'normal',
  fontWeight: 'normal',
  src: `url(${MetropolisRegular}) format('woff2')`,
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1536,
      xl: 1800,
    },
  },
  palette: {
    primary: {
      main: 'rgb(20,59,89)',
      light: 'rgb(74,103,140)',
      dark: 'rgb(0,28,40)',
      contrastText: '#ffffff',
    },
    secondary: {
      main: 'rgb(58,152,75)',
      light: 'rgb(112,196,126)',
      dark: 'rgb(0,113,26)',
      contrastText: '#000000',
    },
    error: {
      main: '#f44336',
      light: '#ff7961',
      dark: '#ba000d',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ff9800',
      light: '#ffc947',
      dark: '#c66900',
      contrastText: '#000000',
    },
    info: {
      main: '#2196f3',
      light: '#6ec6ff',
      dark: '#0069c0',
      contrastText: '#ffffff',
    },
    success: {
      main: '#4caf50',
      light: '#80e27e',
      dark: '#087f23',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"MetropolisRegular", sans-serif',
    h1: {
      fontSize: '2.5rem',
    },
    h2: {
      fontSize: '2rem',
    },
    h3: {
      fontSize: '1.75rem',
    },
    h4: {
      fontSize: '1.5rem',
    },
    h5: {
      fontSize: '1.25rem',
    },
    h6: {
      fontSize: '1rem',
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
    button: {
      fontSize: '0.875rem',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: [{ '@font-face': metropolisRegular }],
      },
    },
  },
});

export default theme;
